import React from 'react';
import { makeStyles } from '@material-ui/core';

import { onAttachmentClick } from '../../../utils/httpUtil';
import { shrinkName } from '../../../utils';
import { useAppWidthClass } from '../../../utils/hooks';

import { Button, CustomIcon } from '../../common';
import {
  ICON_MAP,
  MAX_DOC_SIZE_LG,
  MAX_DOC_SIZE_MOBILE,
  MAX_DOC_SIZE_TABLET
} from './index';

const useStyles = makeStyles(theme => ({
  fileList: {
    display: 'flex',
    flexDirection: 'column',
    margin: `${theme.spacing(1)}px 0 0 0`,
    padding: 0
  },
  file: {
    width: '100%',
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'flex-start',
    textAlign: 'left',
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.text.disabled}`,
    borderRadius: theme.shape.borderRadius * 2,
    background: theme.palette.background.default,
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    transition: theme.transitions.custom.fast,

    '&:hover': {
      borderColor: theme.palette.text.hint,
      color: theme.palette.text.primary,
      boxShadow: theme.customShadows.active
    },
    '&:focus,&:active': {
      outline: 'none'
    }
  },
  fileIcon: {
    marginRight: theme.spacing(2)
  },
  fileIconSmallMargin: {
    marginRight: theme.spacing(1)
  },
  fileName: {
    ...theme.typography.subtitle2,
    paddingTop: theme.spacing(0.5),
    color: 'inherit',
    wordBreak: 'break-word',
    whiteSpace: 'normal'
  }
}));

const NotificationFileList = ({ compact, files }) => {
  const classes = useStyles();
  const { isTabletWidth, isMobileWidth } = useAppWidthClass();

  return (
    <ul className={classes.fileList}>
      {files.map(({ url, name, fileName }, index) => (
        <Button
          key={url}
          variant="native"
          className={classes.file}
          onClick={onAttachmentClick(url)}
          data-testid={`page.postbox.component.notification.file-link.${index}`}
        >
          <CustomIcon
            className={compact ? classes.fileIconSmallMargin : classes.fileIcon}
            size="small"
            icon={ICON_MAP[fileName] ? ICON_MAP[fileName] : 'mailIcon'}
            variant="primary"
          />
          <div className={classes.fileName}>
            {shrinkName(
              name,
              !isMobileWidth && !isTabletWidth
                ? MAX_DOC_SIZE_LG
                : isMobileWidth
                ? MAX_DOC_SIZE_MOBILE
                : MAX_DOC_SIZE_TABLET
            )}
          </div>
        </Button>
      ))}
    </ul>
  );
};

export default NotificationFileList;
